import { PlusIcon } from '../../icons';
import { OrientationPluginIcon } from '../../icons/OrientationPluginIcon';
import { alwaysActiveResolver, alwaysVisibleResolver } from '../../resolvers/tiptapResolvers';
import type { IToolbarItemConfig } from '../../types';

export const switcherItemsConfigs: Omit<IToolbarItemConfig, 'commands'>[] = [
  {
    id: 'FORMATTING_ORIENTATION_SWITCH',
    type: 'toggle',
    presentation: {
      tooltip: 'Formatting Switch',
      icon: PlusIcon,
    },
    attributes: {
      visible: alwaysVisibleResolver,
    },
  },
  {
    id: 'FORMATTING_ORIENTATION_SWITCH_ADD_MENU',
    type: 'toggle',
    presentation: {
      tooltip: 'Formatting Switch',
      icon: PlusIcon,
    },
    attributes: {
      visible: alwaysVisibleResolver,
    },
  },
  {
    id: 'FORMATTING_ORIENTATION_SWITCH_OPEN',
    type: 'toggle',
    presentation: {
      tooltip: 'Formatting Switch',
      icon: () => PlusIcon({ style: { transform: 'rotate(45deg)' } }),
    },
    attributes: {
      visible: alwaysVisibleResolver,
      active: alwaysActiveResolver,
    },
  },
  {
    id: 'PLUGINS_ORIENTATION_SWITCH',
    type: 'toggle',
    presentation: {
      tooltip: 'Plugins Switch',
      icon: () => OrientationPluginIcon({ style: { transform: 'rotateY(180deg)' } }),
    },
    attributes: {
      visible: alwaysVisibleResolver,
    },
  },
  {
    id: 'PLUGINS_ORIENTATION_SWITCH_OPEN',
    type: 'toggle',
    presentation: {
      tooltip: 'Plugins Switch',
      icon: () => OrientationPluginIcon({}),
    },
    attributes: {
      visible: alwaysVisibleResolver,
      active: alwaysActiveResolver,
    },
  },
];
